import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

// Define the context type
interface SupportInstanceSelectionContextType {
  selectedSupportCustomerIntegrationId: number | null;
  setSelectedSupportCustomerIntegrationId: (id: number | null) => void;
}

// Create the context with default values
const SupportInstanceSelectionContext = createContext<SupportInstanceSelectionContextType>({
  selectedSupportCustomerIntegrationId: null,
  setSelectedSupportCustomerIntegrationId: () => {},
});

// Custom hook to use the support instance selection context
export const useSupportInstanceSelection = () => useContext(SupportInstanceSelectionContext);

// Provider component
export const SupportInstanceSelectionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Initialize state from localStorage if available
  const [selectedSupportCustomerIntegrationId, setSelectedSupportCustomerIntegrationId] = useState<number | null>(() => {
    const savedInstance = localStorage.getItem('selectedSupportCustomerIntegrationId');
    return savedInstance ? Number(savedInstance) : null;
  });

  // Save to localStorage whenever selectedSupportCustomerIntegrationId changes
  useEffect(() => {
    if (selectedSupportCustomerIntegrationId !== null) {
      localStorage.setItem('selectedSupportCustomerIntegrationId', selectedSupportCustomerIntegrationId.toString());
    }
  }, [selectedSupportCustomerIntegrationId]);

  return (
    <SupportInstanceSelectionContext.Provider value={{ selectedSupportCustomerIntegrationId, setSelectedSupportCustomerIntegrationId }}>
      {children}
    </SupportInstanceSelectionContext.Provider>
  );
};
